import { FETCH_NEWS, SET_NEWS, START_LOADING_NEWS, END_LOADING_NEWS } from "../constants/news";

export default (state = { isLoading: false, news: "" }, action) => {
  switch (action.type) {
    case START_LOADING_NEWS:
      return { ...state, isLoading: true };
    case END_LOADING_NEWS:
      return { ...state, isLoading: false };
    case FETCH_NEWS:
      return { ...state, news: action.payload.data };
    case SET_NEWS:
      return { ...state, news: action.payload };
    default:
      return state;
  }
};
